export const GLOBAL_NOTIFICATION_ID = 'global-notification';

// notification menu
export const NOTIFICATION_MENU_ISSUE_ALERT_PAGE_SIZE = 30;
export const NOTIFICATION_MENU_ACTIVITY_PAGE_SIZE = 30;
export const NOTIFICATION_MENU_TRIGGER_FETCH_HEIGHT = 500;

// notification centre
export const NOTIFICATION_CENTRE_PERFORMANCE_API_INTERVAL = 60000;
export const NOTIFICATION_CENTRE_PERFORMANCE_DATE_RANGE = 5;

export const NOTIFICATION_FETCH_INTERVAL_SCALE_KEY =
	'NOTIFICATION_FETCH_INTERVAL_SCALE';
/* use this in console to avoid update interval:
localStorage.setItem('NOTIFICATION_FETCH_INTERVAL_SCALE',9527)

and use this line to reset:
localStorage.removeItem('NOTIFICATION_FETCH_INTERVAL_SCALE')
*/
const INTERVAL_SCALE = window.localStorage.getItem(
	NOTIFICATION_FETCH_INTERVAL_SCALE_KEY
)
	? parseFloat(
			window.localStorage.getItem(NOTIFICATION_FETCH_INTERVAL_SCALE_KEY) || '1'
		)
	: 1;

export const NOTIFICATION_POLLING_INTERVAL_IN_SECONDS = 3 * INTERVAL_SCALE;
export const NOTIFICATION_ACTIVITY_POLLING_INTERVAL_IN_SECONDS =
	10 * INTERVAL_SCALE;
export const NOTIFICATION_POSSIBLE_SYSTEM_DELAY_IN_SECONDS =
	NOTIFICATION_POLLING_INTERVAL_IN_SECONDS / 2;

export enum NotificationMenuTabs {
	ISSUE_AND_ALERT = 'issue-alert',
	ACTIVITY = 'activity',
}

export enum IssueCentreTabs {
	'PERFORMANCE' = '0',
	'ISSUE_ALERT' = '1',
	'ACTIVITY' = '2',
}

export enum NotificationType {
	'ISSUE_ALERT' = 'issue-alert',
	'ACTIVITY' = 'activity',
}

export enum PostMessageType {
	'MESSAGE' = 'message',
	'TOKEN' = 'fcmToken',
	'NOTIFICATION' = 'notification',
	'NAVIGATION' = 'navigation',
	'LOGOUT' = 'logout',
	'USER' = 'user',
	'UNREAD_COUNT' = 'unread-count',
	'READ_NOTIFICATION' = 'read-notification',
	'UNREAD_NOTIFICATION' = 'unread-notification',
	'RELOAD' = 'reload',
}

export const NOTIFICATION_FIRST_SOUND_TIME = 0; //in minutes
export enum TimeInterval {
	DAILY = 'P1D',
	WEEKLY = 'P1W',
	MONTHLY = 'P1M',
	YEARLY = 'P1Y',
}
